import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IOrder } from "mobx-stores/_models/orders/order";
import { useStores } from "mobx-stores/_root-store";
import { CustomerDealingAndActiveInfo } from "pages/common/customer-dealing-and-active-info";
import { ProductNameAndActiveInfo } from "pages/common/product-name-and-active-info";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NumberText } from "share-components/atomics/number-text";
import {
  DetailIconButton,
  ExpandButton,
} from "share-components/mui-wrap/button/action-button";
import { XGroupCell } from "share-components/mui-wrap/table/x-group-cell";
import { XSubRow } from "share-components/mui-wrap/table/x-sub-row";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
import { OrderStatus } from "../status";
export const OrderTable = observer(() => {
  const {
    orderManagement: {
      orders,
      getOrders,
      pagination,
      searchConditionAsNaturalLanguage,
    },
  } = useStores();

  useEffect(() => {
    getOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getOrders();
    },
    [getOrders, pagination],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageIndex + 1,
        onChange: onPageChanged,
      }}
      searchConditionAsNaturalLanguage={searchConditionAsNaturalLanguage}
    >
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>STT</TableCell>
          <TableCell>Tên giao dịch</TableCell>
          <TableCell>Ngày PO</TableCell>
          <TableCell>Số PO</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {orders.map((x, i) => (
          <Row data-id={x.id} key={x.id} order={x}></Row>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
type RowProps = {
  order: IOrder;
};
const Row = observer(({ order }: RowProps) => {
  const {
    orderManagement: { setProp },
  } = useStores();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const goDetailHandler = useCallback(
    (order: IOrder) => {
      navigate(`${order.id}`);
      setProp("orderDetail", cloneDeep(order));
    },
    [navigate, setProp],
  );
  return (
    <Fragment>
      <TableRow hover>
        <TableCell sx={{ width: "30px" }}>
          <ExpandButton
            onClick={() => setOpen(!open)}
            open={open}
          ></ExpandButton>
        </TableCell>
        <TableCell>{order.orderNumber || ""}</TableCell>
        <TableCell>
          {order.customer && (
            <CustomerDealingAndActiveInfo
              customer={order.customer}
            ></CustomerDealingAndActiveInfo>
          )}
        </TableCell>
        <TableCell>{dateTimeDisplay(order.poDate || "")}</TableCell>
        <TableCell>{order.poNumber}</TableCell>
        <TableCell width={"20px"}>
          <DetailIconButton
            onClick={() => goDetailHandler(order)}
          ></DetailIconButton>
        </TableCell>
      </TableRow>
      {open && (
        <XSubRow>
          <XGroupCell colSpan={6} headerTitle="Chi tiết mặt hàng">
            <Table>
              <TableHead
                sx={{
                  th: {
                    zIndex: 1,
                  },
                }}
              >
                <TableRow>
                  <TableCell rowSpan={2}>Tên hàng</TableCell>
                  <TableCell rowSpan={2}>Mã hàng</TableCell>
                  <TableCell rowSpan={2}>Mã vạch</TableCell>
                  <TableCell rowSpan={2}>ĐVT</TableCell>
                  <TableCell rowSpan={2}>Ngày giao</TableCell>
                  <TableCell rowSpan={2}>Đơn giá</TableCell>
                  <TableCell colSpan={3} align="center">
                    Số lượng đặt hàng
                  </TableCell>
                  <TableCell rowSpan={2}>Trạng thái</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Trên</TableCell>
                  <TableCell>Chuẩn</TableCell>
                  <TableCell>Dưới</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {order.items.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      {item.product && (
                        <ProductNameAndActiveInfo
                          product={item.product}
                        ></ProductNameAndActiveInfo>
                      )}
                    </TableCell>
                    <TableCell>{item.product?.code || ""}</TableCell>
                    <TableCell>{item.product?.barcode || ""}</TableCell>
                    <TableCell>
                      {item.product?.unitOfCalculation || ""}
                    </TableCell>
                    <TableCell>{dateTimeDisplay(item.deliveryDate)}</TableCell>
                    <TableCell>
                      {item?.unitPrice != null ? (
                        <NumberText value={item?.unitPrice}></NumberText>
                      ) : (
                        "*****"
                      )}
                    </TableCell>

                    <TableCell>
                      <NumberText value={item.quantityUpper}></NumberText>
                    </TableCell>
                    <TableCell>
                      <NumberText value={item.quantityStandard}></NumberText>
                    </TableCell>
                    <TableCell>
                      <NumberText value={item.quantityLower}></NumberText>
                    </TableCell>
                    <TableCell>
                      {item?.status && (
                        <OrderStatus status={item?.status}></OrderStatus>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </XGroupCell>
        </XSubRow>
      )}
    </Fragment>
  );
});
